import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { FilterMenuFooter } from '@calendly/ui/components/filter-menu';
import { Grid } from '@calendly/ui/components/grid';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import { SchedulingFilterMenuContent } from 'components/cui_filter_menu';
import { GridWrapper, ActionsContainer, ClearButton } from './styles';
const schedulingFilterFooterCss = "s1x1vzul";
export const BaseFilterModal = ({
  onClose,
  onApply,
  onClear,
  children
}) => {
  const isPhone = useDeviceType('isPhone');
  return <SchedulingFilterMenuContent aria-label="filter-modal" data-testid="scheduling-filter-menu-content" footer={<FilterMenuFooter className={schedulingFilterFooterCss}>
          <ClearButton decoration="minimal" onClick={onClear}>
            {isPhone ? I18n.t('publisher.action.reset') : I18n.t('publisher.meetings.filter_modal.reset')}
          </ClearButton>
          <ActionsContainer>
            <Button onClick={onClose} responsive={false} decoration="secondary-outline">
              {I18n.t('publisher.action.cancel')}
            </Button>
            <Button onClick={onApply} responsive={false}>
              {I18n.t('publisher.action.apply')}
            </Button>
          </ActionsContainer>
        </FilterMenuFooter>}>
      <GridWrapper>
        <Grid spacing={24}>
          {children}
        </Grid>
      </GridWrapper>
    </SchedulingFilterMenuContent>;
};

require("./base_filter_modal.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./base_filter_modal.js");